import React, { useState, useEffect, useReducer } from 'react';
import { Link, useParams } from 'react-router-dom'
import _ from 'lodash'
import Header from '../../header/Header'
import Footer from '../../footer/Footer'
import ScrollView from 'devextreme-react/scroll-view';
import { Button } from 'devextreme-react/button';
import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import TextArea from 'devextreme-react/text-area';
import NumberBox from 'devextreme-react/number-box';
import DateBox from 'devextreme-react/date-box';
import { TagBox } from 'devextreme-react/tag-box';
import { Validator, RequiredRule, EmailRule, CustomRule } from 'devextreme-react/validator';
import { fetchNominationData, manageNominationData, manageRecognitionData } from '../../../actions/dashboard';
import dashboardReducer from '../../../reducers/dashboard';
import Gallery from 'devextreme-react/gallery';
import moment from 'moment';
import { confirm } from 'devextreme/ui/dialog';
import {
    Popup
} from 'devextreme-react/popup';

const scrollConfig = {
    showScrollbar: 'always',
    scrollByContent: true,
    scrollByThumb: false,
}

const initialState = { allNominations: [] }

const NominationCard = ({ data, setSelectedData, setIsPopupVisible, manageNomination, manageRecognition }) => {
    const { kaizenTitle, kaizenIdea, status, proposer, proposersDepartment, nominationStatus } = data;
    return <div className="nomination_card_container">
        <h4 className="nomination_card_heading">{kaizenTitle}</h4>
        <div className="nomination_card_description">{kaizenIdea}</div>
        <div className="nomination_card_by">{proposer}</div>
        <div className="nomination_card_status">{proposersDepartment}</div>
        <div className="nomination_card_actions">
            <a onClick={() => {
                setSelectedData(data)
                setIsPopupVisible(true)
            }}>View Details</a>
            {data.nominationStatus != 'REJ' ? <>
                <span onClick={() => data.nominationStatus != 'REC' && manageNomination(data)} style={data.recognizedByManager !== true ? { color: 'gray' } : { color: '#1ca8dd' }} data-bs-toggle="tooltip" data-bs-placement="top" title={data.recognizedByManager != true ? "Not Recognized" : "Recognized"}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-currency-dollar" viewBox="0 0 16 16">
                        <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z" />
                    </svg>
                </span>
                <span onClick={() => manageRecognition(data)} style={data.recognition != 'TRUE' ? { color: 'gray' } : { color: '#1ca8dd' }} data-bs-toggle="tooltip" data-bs-placement="top" title={data.recognition == "TRUE" ? "Nominated" : "Not Nominated"}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                    </svg>
                </span>
            </> : ''}
        </div>
        <div className="nomination_status"> <div style={nominationStatus == "TBN" ? { background: "gray" } : (nominationStatus == "REC" ? { background: "green" } : (nominationStatus == "REJ" ? { background: "red" } : { background: "yellow" }))}></div></div>
    </div>
}

const Nomination = props => {
    const { category, site } = useParams()
    const [animate, setAnimate] = useState(null)
    const [selectedData, setSelectedData] = useState(null);
    const [dataList, setDataList] = useState([])
    const [state, dispatch] = useReducer(dashboardReducer, initialState);
    const [isPopupVisible, setIsPopupVisible] = useState(false)

    const { allNominations } = state;

    useEffect(() => {
        fetchNominationData(dispatch, site)
    }, [])

    useEffect(() => {
        if (selectedData) {
            let a = allNominations.find(val => val.id == selectedData.id)
            setSelectedData(a);
        }
    }, [allNominations])

    useEffect(() => {
        const perChunk = 6 // items per chunk    


        const result = allNominations.reduce((resultArray, item, index) => {
            const chunkIndex = Math.floor(index / perChunk)

            if (!resultArray[chunkIndex]) {
                resultArray[chunkIndex] = [] // start a new chunk
            }

            resultArray[chunkIndex].push(item)

            return resultArray
        }, [])
        setDataList(result)
    }, [allNominations])

    useEffect(() => {
        setTimeout(() => {
            setAnimate('animate')
        }, 250);
    }, []);

    useEffect(() => {
    }, [isPopupVisible])


    const manageNomination = (data) => {
        confirm('Are you sure that you want to recognize?', 'Recognize Kaizen')
            .then(() => {
                const payload = {
                    ...data,
                    recognizedByManager: true,
                    id: +data.id,
                    siteCode: site,
                }
                manageNominationData(dispatch, payload)
            })
            .catch(err => console.log(err))
    }

    const manageRecognition = (data) => {
        confirm(data.recognition == "TRUE" ? 'Are you sure that you want to remove this from nomination?' : 'Are you sure that you want to nominate?', 'Nominate Kaizen')
            .then(() => {
                const payload = {
                    ...data,
                    recognition: data.recognition == "TRUE" ? null : "TRUE",
                    id: +data.id,
                    siteCode: site,
                }
                manageRecognitionData(dispatch, payload)
            })
            .catch(err => console.log(err))
    }

    const gridRenderer = (data) => {
        return <div className="nomination_carousel_data">
            {data && data.map(data => {
                return <>
                    <NominationCard data={data} setSelectedData={setSelectedData} manageRecognition={manageRecognition} manageNomination={manageNomination} setIsPopupVisible={setIsPopupVisible} />
                </>
            })}

        </div>
    }

    return (
        <>
            <Header showPinBtn={false} site={[]} />

            <section className="page-content">
                <div className="site-view tier-wrap">
                    <div className={"site-list " + animate}>
                        <div className="breadcrumb nomination-breadcrumb">

                            <div className="br-part">
                                <span className="icon icon-corporate"></span>
                                <ul>
                                    <li><Link to={`/`}>Home</Link></li>
                                    <li><Link to={`/siteApp/${category}/${site}/kaizen`}>Kaizen</Link></li>
                                    <li><b>Nomination</b></li>
                                </ul>
                            </div>
                            <div className="br-part">
                                <div className="d-flex nomination-statuses w-100" style={{ justifyContent: "flex-end" }}>
                                    <div className="d-flex nomination-statuses" style={{ marginRight: "10px" }}>
                                        <div className="not-nominated"></div>
                                        <div>Not Nominated</div>
                                    </div>
                                    <div className="d-flex nomination-statuses" style={{ marginRight: "10px" }}>
                                        <div className="nominated"></div>
                                        <div>Nominated</div>
                                    </div>
                                    <div className="d-flex nomination-statuses" style={{ marginRight: "10px" }}>
                                        <div className="recognized"></div>
                                        <div>Recognized</div>
                                    </div>
                                    <div className="d-flex nomination-statuses" style={{ marginRight: "10px" }}>
                                        <div className="rejected"></div>
                                        <div>Rejected</div>
                                    </div>
                                </div>
                            </div>
                            <div className="br-part">
                                <div>
                                    Total : <b>{allNominations.length}</b>
                                </div>
                            </div>

                        </div>

                        <div className="nomination_container site-body scroll">
                            {allNominations.length ? <ScrollView
                                id="tierApps"
                                {...scrollConfig}
                            >
                                <Gallery
                                    id="gallery"
                                    dataSource={dataList}
                                    height='100%'
                                    width='100%'
                                    showNavButtons={dataList.length > 1}
                                    showIndicator={false}
                                    itemRender={gridRenderer} />
                            </ScrollView> : <div style={{ width: '100%', textAlign: 'center', marginTop: '80px' }}>No data.</div>}
                        </div>
                    </div>
                </div>
            </section>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Footer showThemeSwitch={true} container="admin-console" hideSiteCount={true} activeSites={[]} sbg={[]} />
            </div>

            {isPopupVisible &&
                <Popup
                    mode="popup"
                    width={1400}
                    height="content-fit"
                    showTitle={true}
                    title={selectedData.kaizenTitle}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    onHiding={() => {
                        setIsPopupVisible(false)
                        selectedData(null)
                    }}
                    visible={isPopupVisible}
                >
                    <ScrollView
                        id="scrollview"
                        {...scrollConfig}
                    >
                        <div className="d-flex kreg-info">
                            <div className=" alerts-flex-container nomination-popup" >
                                <div className="kreg-item">
                                    <label >Category</label>
                                    <span> {selectedData.category || '-'}</span>
                                </div>

                                <div className="kreg-item">
                                    <label >TTI Category</label>
                                    <span> {selectedData.ttiCategory || '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Lines</label>
                                    <span> {selectedData.lines || '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Status</label>
                                    <span> {selectedData.status || '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Collaborated With</label>
                                    <span> {selectedData?.assignedTo || '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Cost/Revenue Impact($)</label>
                                    <span> {selectedData.costImpact}</span>
                                </div>
                                <div className="kreg-item nomination-description">
                                    <label >Description</label>
                                    <span> {selectedData.kaizenIdea}</span>
                                </div>
                                <br />
                                <div className="kreg-item w-100">
                                    <label >Attachments</label>
                                    <span>No files attached</span>
                                </div>
                            </div>
                            <div className="alerts-flex-container nomination-popup" >
                                <div className="kreg-item">
                                    <label >Area</label>
                                    <span> {selectedData.location || '-'}</span>
                                </div>

                                <div className="kreg-item">
                                    <label >Cell</label>
                                    <span> {selectedData.module || '-'}</span>
                                </div>

                                <div className="kreg-item">
                                    <label >Proposer</label>
                                    <span> {selectedData.proposer || '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Approver</label>
                                    <span> {selectedData.ttiApprover || '-'}</span>
                                </div>

                                <div className="kreg-item">
                                    <label >Raised On</label>
                                    <span> {selectedData.created ? moment(selectedData.created).format('MM/DD/YYYY') : '-'}</span>
                                </div>
                                <div className="kreg-item">
                                    <label >Completed On</label>
                                    <span> {selectedData.completedDat ? moment(selectedData.completedDate).format('MM/DD/YYYY') : '-'}</span>
                                </div>

                                <div className="kreg-item">
                                    <label >Solution</label>
                                    <span> {selectedData.actionTaken || '-'}</span>
                                </div>
                            </div>
                        </div>
                        <div className={'d-flex nomination-bottom-buttons p-3'}>
                            {selectedData.nominationStatus != 'REJ' ? <>
                                <span onClick={() => selectedData.nominationStatus != 'REC' && manageNomination(selectedData)} style={selectedData.recognizedByManager !== true ? { color: 'gray' } : { color: '#1ca8dd' }} data-bs-toggle="tooltip" data-bs-placement="top" title={props?.data.recognizedByManager != true ? "Not Recognized" : "Recognized"}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-currency-dollar" viewBox="0 0 16 16">
                                        <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z" />
                                    </svg>
                                </span>
                                <span onClick={() => manageRecognition(selectedData)} style={selectedData.recognition != 'TRUE' ? { color: 'gray', paddingLeft: "10px" } : { color: '#1ca8dd', paddingLeft: "10px" }} data-bs-toggle="tooltip" data-bs-placement="top" title={props?.data.recognition == "TRUE" ? "Nominated" : "Not Nominated"}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                    </svg>
                                </span>
                            </> : ''}
                        </div>
                    </ScrollView>
                </Popup>
            }
        </>
    )
};
export default Nomination
